import { Modal } from "react-bootstrap";
import React, { useEffect } from "react";
import { FormGroup, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { verifyResetEmailStart } from "../../store/actions/UserAction";
import { clearResetEmail } from "../../store/actions/UserAction";
import { clearInvalidEmail } from "../../store/actions/UserAction";
import OutlinedTextField from "../Input/OutlinedTextField";
import SecondaryButton from "../Buttons/SecondaryButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import { getSiteName } from "../../utils/brandingConfig";

export default function ForgotPasswordModal({ open, onClose, setShow }) {
  const siteName = getSiteName();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
  } = useForm();

  const dispatch = useDispatch();
  const verifyResetEmail = useSelector((state) => state.users.verifyResetEmail);
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (verifyResetEmail.error) {
      setError("email", {
        message: verifyResetEmail.error,
      });
    }
  }, [verifyResetEmail]);

  //clear all the persisted states.
  useEffect(() => {
    dispatch(clearResetEmail());
    clearErrors();
    return () => {
      dispatch(clearResetEmail());
      clearErrors();
    };
  }, []);

  //api call for forgot password
  const handleResetPassword = (data) => {
    if (!verifyResetEmail.isManualLogin) {
      handleCloseModal();
      return navigate("/login");
    }
    if (verifyResetEmail.invalidEmail) {
      return navigate("/register");
    }
    return dispatch(verifyResetEmailStart(data));
  };

  const handleCloseModal = () => {
    onClose(params, verifyResetEmail?.sentVerificationMail);
    setTimeout(() => {
      clearErrors();
      dispatch(clearResetEmail());
    }, 400);
  };

  const handleInputChange = () => {
    dispatch(clearInvalidEmail());
  };

  return (
    <>
      <Modal
        contentClassName="login-modal"
        centered
        show={open}
        onHide={handleCloseModal}
      >
        <form onSubmit={handleSubmit(handleResetPassword)} translate="no">
          <Modal.Header className="bg-black login-modal-header">
            Forgot password ?
          </Modal.Header>
          <Modal.Body className="bg-black login-modal-body px-3">
            {verifyResetEmail?.sentVerificationMail ? (
              <p className="py-4 px-2 d-flex justify-content-center align-items-center text-center">
                A password link has been sent to your email, please navigate
                there to finish resetting your password
              </p>
            ) : (
              <>
                <p className="py-4 d-flex justify-content-center align-items-center text-center">
                  If you have a {siteName} account, you will receive a
                  password reset link to this e-mail.
                </p>
                <FormGroup>
                  <OutlinedTextField
                    className="reset-input"
                    placeholder="Email"
                    InputLabelProps={{
                      style: {
                        color: "white",
                      },
                    }}
                    label="Email"
                    classes={{
                      root: "input-root",
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& input:-webkit-autofill": { 
                          WebkitTextFillColor: "white !important", 
                          transition: "background-color 5000s ease-in-out 0s",
                          caretColor: "white",
                        }, 
                      },
                    }}
                    variant="outlined"
                    error={errors?.email}
                    helperText={errors?.email ? errors?.email?.message : null}
                    {...register("email", {
                      required: {
                        value: true,
                        message: "The email field is required.",
                      },
                      onChange: handleInputChange,
                    })}
                  />
                </FormGroup>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-black login-modal-footer p-3">
            <SecondaryButton
              type="button"
              className="btn"
              onClick={handleCloseModal}
              title="Close"
            />

            {!verifyResetEmail?.sentVerificationMail ? (
              <PrimaryButton
                disabled={verifyResetEmail?.buttonDisable}
                type="submit"
                className="button-main"
                isLoading={verifyResetEmail?.loading}
                title={verifyResetEmail?.loadingButtonContent || "Submit"}
              />
            ) : null}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}
